module.exports = __webpack_public_path__ + "img/2024big6.56847c32.png";